export class CreateCatalogRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "federated",
            "baseName": "federated",
            "type": "FederatedConnection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateCatalogRequest.attributeTypeMap;
    }
    constructor() {
    }
}
